import axios from "axios";

export const featureFlagGetEnableForm = () =>
    axios.get("/api/feature-flag/form-enable").then((response) => response.data);
